import React from "react";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";

import AppHeader from "./AppHeader";
import { AppShell } from "./AppShell";
import ScrollToTop from "../components/ScrollToTop";
import RouteGuard from "../components/RouteGuard";

import HomeView from "../views/HomeView";
import MachinesView from "../views/MachinesView";
import MachineDetailsView from "../views/MachineDetailsView";
import MachineAddForm from "../forms/MachineAddForm";
import MachineEditForm from "../forms/MachineEditForm";
import ContractsView from "../views/ContractsView";
import ContractCreateForm from "../forms/ContractCreateForm";
import ContractEditForm from "../forms/ContractEditForm";
import ContractDetailsView from "../views/ContractDetailsView";
import CustomersView from "../views/CustomersView";
import CustomerAddForm from "../forms/CustomerAddForm";
import CustomerEditForm from "../forms/CustomerEditForm";
import CustomerDetailsView from "../views/CustomerDetailsView";
import IncidencesView from "../views/IncidencesView";
import IncidenceCreateForm from "../forms/IncidenceCreateForm";
import IncidenceDetailsView from "../views/IncidenceDetailsView";
import SalesView from "../views/SalesView";
import OnlineSalesView from "../views/OnlineSalesView";
import SaleDetailsView from "../views/SaleDetailsView";
import UsersView from "../views/UsersView";
import UserAddForm from "../forms/UserAddForm";
import UserEditForm from "../forms/UserEditForm";
import UserDetailsView from "../views/UserDetailsView";
import UpdatesView from "../views/UpdatesView";
import UpdateAddForm from "../forms/UpdateAddForm";
import UpdateEditForm from "../forms/UpdateEditForm";
import UpdateDetailsView from "../views/UpdateDetailsView";
import NotFoundView from "../views/NotFoundView";
import AuditView from "../views/AuditView";
import ShiftsView from "../views/ShiftsView";
import ShiftsAdminView from "../views/ShiftsAdminView";
import ShiftsAdminAddForm from "../forms/ShiftsAdminAddForm";
import ArqueosView from "../views/ArqueosView";
import ArqueosSalesView from "../views/ArqueosSalesView";
import PromotersView from "../views/PromotersView";
import PromoterEditForm from "../forms/PromoterEditForm";
import PromoterCreateForm from "../forms/PromoterCreateForm";
import PromoterDetailsView from "../views/PromoterDetailsView";
import ObjectivesView from "../views/ObjectivesView";
import ObjectiveEditForm from "../forms/ObjectiveEditForm";
import ObjectiveCreateForm from "../forms/ObjectiveCreateForm";
import ObjectiveDetailsView from "../views/ObjectiveDetailsView";
import ModuleDetailsView from "../views/ModuleDetailsView";
import ModuleAddForm from "../forms/ModuleAddForm";
import ModuleEditForm from "../forms/ModuleEditForm";
import PasswordRecoveryView from "../views/PasswordRecoveryView";
import PasswordAssignView from "../views/PasswordAssignView";
import PasswordRecoveryClientView from "../views/PasswordRecoveryClientView";
import PasswordAssignClientView from "../views/PasswordAssignClientView";
import MinisView from "../views/MinisView";
import MiniDetailsView from "../views/MiniDetailsView";
import MiniAddForm from "../forms/MiniAddForm";
import MiniEditForm from "../forms/MiniEditForm";
import UserShiftView from "../views/UserShiftView";
import PromoterShiftView from "../views/PromoterShiftView";
import TPVsView from "../views/TPVsView";
import ComissionsView from "../views/ComissionsView";
import ComissionDetailsView from "../views/ComissionDetailsView";
import SupportTicketsView from "../views/SupportTicketsView";
import SupportTicketDetailsView from "../views/SupportTicketDetailsView";
import SupportTicketAddForm from "../forms/SupportTicketAddForm";
import SLAView from "../views/SLAView";
import BowlerView from "../views/BowlerView";
import ManualsView from "../views/ManualsView";
import ManualDetailsView from "../views/ManualDetailsView";
import FAQsView from "../views/FAQsView";
import TechnicalSupportChatView from "../views/TechnicalSupportChatView";
import DatabaseSyncView from "../views/DatabaseSyncView";
import ProposalConfiguratorView from "../views/ProposalConfiguratorView";
import ProposalsView from "../views/ProposalsView";
import ProposalPricesView from "../views/ProposalPricesView";
import ApiDocsView from "../views/ApiDocsView";
import ArqueosDashboardView from "../views/ArqueosDashboardView";
import TrainingView from "../views/TrainingView";
import TrainingAdmin from "../views/TrainingAdmin";
import TrainingAddForm from "../views/TrainingAddForm";
import TrainingEditForm from "../views/TrainingEditForm";
import TrainingTextSection from "../views/TrainingTextSection";
import TrainingTestSection from "../views/TrainingTestSection";
class App extends React.Component {
  render() {
    const { role } = this.props;
    const isAdmin = role === "ADMIN";

    // What we render inside the router is the same; only the chrome changes.
    // RouteGuard enforces the menu permission matrix (utils/permissions.js) on
    // every URL: new routes are guarded by their first path segment — if the
    // segment differs from the feature key, register it in
    // utils/routePermissions.js.
    const Routes = (
      <RouteGuard>
        <ScrollToTop />
        <Switch>
          <Route path="/" exact component={HomeView} />
          <Route path="/training-admin" exact component={TrainingAdmin} />
          <Route path="/training/add" exact component={TrainingAddForm} />
          <Route path="/training/:slug/edit" exact component={TrainingEditForm} />
          <Route path="/training/:userId/:formationSlug/:blockId/text" exact component={TrainingTextSection} />
          <Route path="/training/:userId/:formationSlug/:blockId/test" exact component={TrainingTestSection} />
          <Route path="/training/:id" exact component={TrainingView} />
          <Route path="/machines" exact component={MachinesView} />
          <Route path="/machines/add" exact component={MachineAddForm} />
          <Route path="/machines/:id/edit" component={MachineEditForm} />
          <Route path="/machines/:id" component={MachineDetailsView} />

          <Route path="/contracts" exact component={ContractsView} />
          <Route
            path="/contracts/create"
            exact
            component={ContractCreateForm}
          />
          <Route path="/contracts/:number/edit" component={ContractEditForm} />
          <Route path="/contracts/:number" component={ContractDetailsView} />

          <Route path="/customers" exact component={CustomersView} />
          <Route path="/customers/add" exact component={CustomerAddForm} />
          <Route path="/customers/:id/edit" component={CustomerEditForm} />
          <Route path="/customers/:id" component={CustomerDetailsView} />

          <Route path="/incidences" exact component={IncidencesView} />
          <Route
            path="/incidences/create"
            exact
            component={IncidenceCreateForm}
          />
          <Route path="/incidences/:number" component={IncidenceDetailsView} />

          <Route path="/sales" exact component={SalesView} />

          <Route path="/online-sales" exact component={OnlineSalesView} />

          <Route path="/sales/:id" component={SaleDetailsView} />

          <Route path="/users" exact component={UsersView} />
          <Route path="/users/add" exact component={UserAddForm} />
          <Route path="/users/:id/edit" component={UserEditForm} />
          <Route path="/users/:id" component={UserDetailsView} />

          <Route path="/updates" exact component={UpdatesView} />
          <Route path="/updates/add" exact component={UpdateAddForm} />
          <Route path="/updates/:id/edit" component={UpdateEditForm} />
          <Route path="/updates/:id" component={UpdateDetailsView} />

          <Route path="/audit" exact component={AuditView} />

          <Route path="/shifts" exact component={ShiftsView} />
          <Route path="/shiftsadmin" exact component={ShiftsAdminView} />
          <Route path="/shiftsadmin/add" component={ShiftsAdminAddForm} />

          <Route path="/arqueos" exact component={ArqueosView} />
          <Route path="/arqueossales" exact component={ArqueosSalesView} />
          {isAdmin && <Route path="/pro-dashboard" exact component={ArqueosDashboardView} />}

          <Route path="/promoters" exact component={PromotersView} />
          <Route path="/promoters/:id/edit" component={PromoterEditForm} />
          <Route
            path="/promoters/create"
            exact
            component={PromoterCreateForm}
          />
          <Route path="/promoters/:id" component={PromoterDetailsView} />
          <Route path="/promoter/:Name" component={PromoterShiftView} />

          <Route path="/objectives" exact component={ObjectivesView} />
          <Route
            path="/objectives/:customer/edit"
            component={ObjectiveEditForm}
          />
          <Route
            path="/objectives/create"
            exact
            component={ObjectiveCreateForm}
          />
          <Route
            path="/objectives/:customer"
            component={ObjectiveDetailsView}
          />

          <Route
            path="/passwordrecovery"
            exact
            component={PasswordRecoveryView}
          />
          <Route path="/passwordassign" component={PasswordAssignView} />

          <Route
            path="/passwordrecoveryclient"
            exact
            component={PasswordRecoveryClientView}
          />
          <Route
            path="/passwordassignclient"
            component={PasswordAssignClientView}
          />

          <Route path="/minis" exact component={MinisView} />
          <Route path="/minis/add" exact component={MiniAddForm} />
          <Route path="/minis/:Serial/edit" component={MiniEditForm} />
          <Route path="/minis/:Serial" component={MiniDetailsView} />

          <Route path="/user/:id" component={UserShiftView} />

          <Route path="/tpvs" exact component={TPVsView} />

          <Route path="/comissions" exact component={ComissionsView} />
          <Route path="/comissions/details" component={ComissionDetailsView} />

          <Route path="/supporttickets" exact component={SupportTicketsView} />
          <Route path="/supporttickets/:id" component={SupportTicketDetailsView} />
          <Route path="/supportticketadd" exact component={SupportTicketAddForm} />
          <Route path="/slas" exact component={SLAView} />
          <Route path="/bowler" exact component={BowlerView} />

          <Route path="/support-chat" exact component={TechnicalSupportChatView} />

          <Route path="/manuals" exact component={ManualsView} />
          <Route path="/manuals/:id" component={ManualDetailsView} />

          <Route path="/faqs" exact component={FAQsView} />

          <Route path="/sync" exact component={DatabaseSyncView} />

          <Route path="/proposal-configurator" exact component={ProposalConfiguratorView} />
          <Route path="/proposals" exact component={ProposalsView} />
          <Route path="/proposal-prices" exact component={ProposalPricesView} />

          <Route path="/api-docs" exact component={ApiDocsView} />

          <Route path="*" component={NotFoundView} />
        </Switch>
      </RouteGuard>
    );

    return (
      <AppShell>
        <div className="p-3">{Routes}</div>
      </AppShell>
    );
  }
}

const mapStateToProps = (state) => ({
  role: state.auth.role,
  category: state.auth.category,
});

export default connect(mapStateToProps)(App);
